import React from 'react';

import TabsESG from '../../../components/Tabs/TabsEsg';

const QuestionnaireTabs: React.FC<{
  defaultKey: string;
  QTabs: any[];
  setDefaultKey: React.Dispatch<React.SetStateAction<string>>;
}> = ({defaultKey = undefined, QTabs, setDefaultKey}) => {
  return (
    <TabsESG
      defaultKey={defaultKey ?? undefined}
      array={QTabs}
      noPadding={true}
      setDefaultKey={setDefaultKey}
    />
  );
};

export default QuestionnaireTabs;
